import { useMemo } from "react";
import { ensureBwGroupSuffix } from "./ensureBwGroupSuffix";
import {
  useGetCorpLocations,
  UseGetCorpLocationsProps,
} from "./useGetCorpLocations";

const EMPTY_NAMES: Map<string, string> = new Map();

// locationId -> locationName lookup for LOCATION hierarchy nodes (raw `name`
// is a numeric id). Keys are the canonical BW form (G-suffixed) since the
// hierarchy serves externalIds that way (PRDDEV-61695) -- lookups must
// canonicalize with ensureBwGroupSuffix too. Display-only: empty while
// loading or on failure, so consumers fall back to the raw name -- never
// gate data on this.
export const useLocationNameById = (
  options: UseGetCorpLocationsProps,
): Map<string, string> => {
  const { data } = useGetCorpLocations(options);

  return useMemo(() => {
    if (!Array.isArray(data)) return EMPTY_NAMES;

    const map = new Map<string, string>();
    data.forEach((location) => {
      if (!location || typeof location !== "object") return;
      const { locationId, locationName } = location;
      if (locationId === undefined || locationId === null) return;
      if (!locationName) return;
      map.set(ensureBwGroupSuffix(locationId), locationName);
    });
    return map;
  }, [data]);
};
